/**
 * #update_request_context.ts
 *
 * Code generated by ts-proto. DO NOT EDIT.
 * @packageDocumentation
 */
/* eslint-disable */
import _m0 from "protobufjs/minimal.js";
import { messageTypeRegistry } from "../../../../typeRegistry.js";
function createBaseUpdateRequestContextEffect() {
    return {};
}
export const UpdateRequestContextEffect = {
    $type: "devvit.ui.effect_types.v1alpha.UpdateRequestContextEffect",
    encode(_, writer = _m0.Writer.create()) {
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseUpdateRequestContextEffect();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(_) {
        return {};
    },
    toJSON(_) {
        const obj = {};
        return obj;
    },
    create(base) {
        return UpdateRequestContextEffect.fromPartial(base ?? {});
    },
    fromPartial(_) {
        const message = createBaseUpdateRequestContextEffect();
        return message;
    },
};
messageTypeRegistry.set(UpdateRequestContextEffect.$type, UpdateRequestContextEffect);
function createBaseUpdateRequestContextEvent() {
    return { signedRequestContext: "" };
}
export const UpdateRequestContextEvent = {
    $type: "devvit.ui.effect_types.v1alpha.UpdateRequestContextEvent",
    encode(message, writer = _m0.Writer.create()) {
        if (message.signedRequestContext !== "") {
            writer.uint32(10).string(message.signedRequestContext);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseUpdateRequestContextEvent();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.signedRequestContext = reader.string();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            signedRequestContext: isSet(object.signedRequestContext) ? globalThis.String(object.signedRequestContext) : "",
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.signedRequestContext !== "") {
            obj.signedRequestContext = message.signedRequestContext;
        }
        return obj;
    },
    create(base) {
        return UpdateRequestContextEvent.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseUpdateRequestContextEvent();
        message.signedRequestContext = object.signedRequestContext ?? "";
        return message;
    },
};
messageTypeRegistry.set(UpdateRequestContextEvent.$type, UpdateRequestContextEvent);
function isSet(value) {
    return value !== null && value !== undefined;
}
